import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes, FaDownload, FaExpand } from 'react-icons/fa';
import './ResumeModal.css';

const ResumeModal = ({ isOpen, onClose }) => {
    // Close on Escape key
    useEffect(() => {
        const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
        if (isOpen) window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [isOpen, onClose]);

    // Prevent body scroll while open
    useEffect(() => {
        document.body.style.overflow = isOpen ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [isOpen]);

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="resume-modal-overlay"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={onClose}
                >
                    <motion.div
                        className="resume-modal"
                        initial={{ opacity: 0, scale: 0.85, y: 40 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.85, y: 40 }}
                        transition={{ type: 'spring', stiffness: 300, damping: 25 }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Header bar */}
                        <div className="resume-modal-header">
                            <span className="resume-modal-title">Resume Preview</span>
                            <div className="resume-modal-actions">
                                <a
                                    href="/resume.pdf"
                                    download
                                    className="resume-action-btn"
                                    title="Download"
                                >
                                    <FaDownload />
                                    <span>Download</span>
                                </a>
                                <a
                                    href="/resume.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="resume-action-btn"
                                    title="Open in new tab"
                                >
                                    <FaExpand />
                                    <span>Fullscreen</span>
                                </a>
                                <button className="resume-close-btn" onClick={onClose} aria-label="Close">
                                    <FaTimes />
                                </button>
                            </div>
                        </div>

                        {/* PDF iframe */}
                        <div className="resume-modal-body">
                            <iframe
                                src="/resume.pdf#toolbar=0&navpanes=0"
                                title="Resume"
                                className="resume-iframe"
                                allowFullScreen
                            />
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default ResumeModal;
